import { z } from "zod/v4";
import { dbmSlotRowSchema } from "../../schemas/bis";
import { fetchApi } from "../client/internal";

export interface DbmParams {
	season?: number;
	ageCategory?: string;
	gender?: string;
}

export const dbm = {
	list: (params: DbmParams = {}) => {
		const query = new URLSearchParams();
		if (params.season != null) query.set("season", String(params.season));
		if (params.ageCategory) query.set("ageCategory", params.ageCategory);
		if (params.gender) query.set("gender", params.gender);
		const qs = query.toString();
		return fetchApi(`/dbm${qs ? `?${qs}` : ""}`, z.array(dbmSlotRowSchema));
	},
};
